export const TASKS_PARTNER_FILTER_EVENTS= {
  TASKS_PARTNER_FILTER_ALL: 'tasks-filter-partner-all',
  TASKS_PARTNER_FILTER_MAIN: 'tasks-filter-partner-main',
};

export const TASKS_PERIOD_FILTER_EVENTS = {
  TASKS_PERIOD_FILTER_ALL: 'tasks-period-filter-all',
  TASKS_PERIOD_FILTER_TODAY: 'tasks-period-filter-today',
  TASKS_PERIOD_FILTER_TOMORROW: 'tasks-period-filter-tomorrow',
  TASKS_PERIOD_FILTER_WEEK: 'tasks-period-filter-week',
  TASKS_PERIOD_FILTER_MONTH: 'tasks-period-filter-month',
};

export const TASKS_POPUP_PERIOD_EVENTS = {
  TASK_FINISH_DATE: 'task-finish-date',
};
